import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { DOMAINES, IMG } from "@/data/content";
import { Reveal } from "@/lib/motion";
import { scrollToId } from "@/components/SmoothScroll";
import ServiceModal from "@/components/ServiceModal";

export default function Domaines() {
    const rm = useReducedMotion();
    const navigate = useNavigate();
    const [sel, setSel] = useState(null);

    const openDevis = () => {
        setSel(null);
        setTimeout(() => scrollToId("contact"), 60);
    };
    const goSecondary = (to) => {
        setSel(null);
        navigate(to);
    };

    return (
        <section className="relative py-28 overflow-hidden bg-ink" data-testid="domaines-section">
            <div className="absolute inset-0 z-0">
                <img src={IMG.manifesto} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-40" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(6,21,41,0.92), rgba(10,37,64,0.9) 50%, rgba(6,21,41,0.94))" }} />
            </div>
            <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
                <div className="text-center mb-14">
                    <Reveal className="flex items-center justify-center gap-3 mb-5">
                        <span className="h-px w-10 bg-white/20" />
                        <span className="text-[11px] uppercase tracking-[0.2em] text-electric-soft font-body font-semibold">{DOMAINES.kicker}</span>
                        <span className="h-px w-10 bg-white/20" />
                    </Reveal>
                    <Reveal delay={0.05}><h2 className="text-3xl sm:text-4xl font-medium text-white font-display mb-5">{DOMAINES.title}</h2></Reveal>
                    <Reveal delay={0.1}><p className="text-white/60 text-sm sm:text-base leading-relaxed max-w-3xl mx-auto font-body">{DOMAINES.intro}</p></Reveal>
                </div>

                <motion.div
                    className="flex flex-wrap justify-center gap-3"
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.035 } } }}
                >
                    {DOMAINES.items.map((it, i) => {
                        const V = { hidden: { opacity: 0, y: rm ? 0 : 12 }, show: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
                        return (
                            <motion.button
                                variants={V}
                                key={i}
                                type="button"
                                onClick={() => setSel(i)}
                                data-testid={`domaine-badge-${i}`}
                                aria-haspopup="dialog"
                                className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium font-body backdrop-blur-sm transition-all duration-300 ease-out bg-white/[0.07] text-white/75 border border-white/12 hover:bg-white/15 hover:text-white hover:border-electric/50 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-electric focus:ring-offset-2 focus:ring-offset-ink cursor-pointer"
                            >
                                {it.label}
                                <span className="w-4 h-4 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-electric transition-colors duration-300">
                                    <Plus className="w-2.5 h-2.5 text-white" />
                                </span>
                            </motion.button>
                        );
                    })}
                </motion.div>
            </div>

            <ServiceModal
                open={sel !== null}
                fiche={sel !== null ? DOMAINES.items[sel] : null}
                onClose={() => setSel(null)}
                onDevis={openDevis}
                onSecondary={goSecondary}
            />
        </section>
    );
}
